module.exports = __webpack_public_path__ + "static/media/gc-confirmed.8be0adce.svg";